import { useContext, useState, useEffect } from "react";
import {
  StartContainer,
  ImageSvgRes,
  ImageHeader,
} from "../../styles/Screens/Welcome";
import { Text, Title } from "../../styles/Texts";
import { T } from "../../styles/Theme";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import ReactGA from "react-ga4";
import { ADVISER_IDENTIFIER, QUESTIONS_API_URL } from "../../env";
import { GenericButton } from "../../components/UI-KIT/GenereicButton";
import { EssentialsDataContext } from "../../Contexts/EssentialsDataContext";
import { DataInitialSetup } from "../../Interfaces/IInitialSetup";
import TextValues from "../../TextValues/index.json";
import styled from "styled-components";
import { uploadEventRequest } from "../../utils/requests";

export const Welcome = () => {
  const [, , screenNumber, setScreenNumber] = useContext(EssentialsDataContext);

  const sendEvent = () => {
    const code: string = `${ADVISER_IDENTIFIER}[m8fgz8@7gc782.entelequipos]`;
    const body: any = JSON.stringify({
      data: {eventName: "next", tag: "P0", content: "Quiero comenzar"}
    });
    uploadEventRequest(body, code).then((res) => void(0));
  };

  const handleStart = () => {
    setScreenNumber(screenNumber + 1);
    sendEvent();
  };

  const [settings, setSettings] = useState<DataInitialSetup | null>(null);

  useEffect(() => {
    const url = `${QUESTIONS_API_URL}/${ADVISER_IDENTIFIER}/settings/`;
    axios.get(url).then((res) => setSettings(res.data.data[0]));
  }, []);

  return (
    <StartContainer>
      <ImageSvgRes>
        <ImageHeader />
      </ImageSvgRes>
      
      <TitleContainer>
        <Title>
          <TextDescriptionConatiner>
            {settings ? settings.title : <Skeleton />}
          </TextDescriptionConatiner>
          </Title>
          
      </TitleContainer>
      <DescriptionContainer>
        <Text>
          <TextTitleConatiner>
            {settings ? settings.description : <Skeleton count={4} />}
          </TextTitleConatiner>  
        </Text>
      </DescriptionContainer>

      <div className="buttonContainer">
        <GenericButton bg={T.primary} c="white" onClick={handleStart}>
          {TextValues.buttons.initialSetup}
        </GenericButton>
      </div>
    </StartContainer>
  );
};


const TitleContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
  margin-left: 50px;
  margin-right: 50px;
  color: #000000;

  @media(max-width: 480px) {
    margin-right: 20px;
    margin-left: 20px;
    color: #000000;
  }
`;

const DescriptionContainer = styled.div`
  margin-right: 50px;
  margin-left: 50px;
  color: #000000;

  @media(max-width: 480px) {
    color: #000000;
    margin-right: 20px;
    margin-left: 20px;
  }
`;

const TextTitleConatiner = styled.p`
  font-weight: 
  @media(max-width: 480px) {
    font-size: ${T.fontSizes.large};
  }
`;

const TextDescriptionConatiner = styled.p`
  @media(max-width: 480px) {
    font-weight: ${T.fontWeights.bold};
  }
`;
